module.exports = __webpack_public_path__ + "img/full2-min.599b6763.png";